import { SortDirection } from '../../models/sort.model';

export interface DataViewColumn {
  /** Display name shown in the table header */
  name: string;
  /** Used as the CSS class suffix (`col-{key}`) and as the sort event key */
  key: string;
  /** Whether this column is sortable */
  sortable?: boolean;
  /**
   * When true the column header and matching td cells become sticky on the
   * x-axis so horizontal scroll only affects the non-fixed columns.
   * Use `.col-{key}` in your host SCSS to set the explicit `left` offset when
   * stacking multiple fixed columns.
   */
  fixed?: boolean;
  /**
   * Return `true` to hide the column at the given container pixel width.
   * The component re-evaluates this on every ResizeObserver tick.
   */
  hidden?: (containerWidth: number) => boolean;
}

export interface DataViewDataSource<T = unknown> {
  items: T[];
  totalItems: number;
  loading: boolean;
  currentPage: number;
  pageSize: number;
  /** Set to `true` once the very first successful response has been received */
  hasEverLoaded?: boolean;
}

export type DataViewMode = 'table' | 'grid';

export interface DataViewSortEvent {
  column: string;
  direction: SortDirection;
}
